module.exports = __webpack_public_path__ + "static/media/institute-24-min.5fcdd6f8.webp";